module.exports = {
	"ru": {
		"Domain": "Домен",
		"Username": "Имя пользователя",
		"Password": "Пароль",
		"Log In": "Войти",
		"Error": "Ошибка",
		"Invalid credentials": "Неверные данные входа"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/routes/login/strings.yaml
// module id = 777
// module chunks = 0